import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {
    addFromColumn,
    sortCurrency,
    sortNumber,
    toCurrency,
} from '../shared/functions';
import {setDefaultTableSort, getTableState, filterCaseInsensitive} from '../shared/tableFunctions';
import {convertStartAndEndDatesForFile} from '../shared/printFunctions';
import ReactTable from 'react-table';
import {CSVLink} from 'react-csv';
import '../shared/react-table.css';
import {commonStyles} from '../shared/styles';
import {tableStyles} from '../shared/styles-table';
import FlatButton from 'material-ui/FlatButton';
import ExportIcon from 'material-ui/svg-icons/navigation/arrow-downward';
import DetailIcon from 'material-ui/svg-icons/image/remove-red-eye';
import TableIcon from 'material-ui/svg-icons/action/grade';

/**
 * Class for displaying Location Sales in a table
 *
 */
class LocationSalesTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            summaryList: [],
            summaryTableData: [],
            summaryTableHeaders: [
                {label: 'Location ID', key: 'location_id'},
                {label: 'Location Name', key: 'location_name'},
                {label: 'City', key: 'city'},
                {label: 'State', key: 'state'},
                {label: 'DBA', key: 'dba_name'},
                {label: 'Total Items Sold', key: 'total_sold'},
                {label: 'Total Returned', key: 'total_returned'},
                {label: 'Net Sales', key: 'net_total'}
            ],
        };
    }

    componentWillMount() {
        this.processData(this.props.listData);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.listData !== this.props.listData) {
            this.setState({
                summaryList: nextProps.listData,
                summaryTableData: nextProps.listData
            });
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.listData !== this.props.listData) {
            this.processData(this.props.listData);
        }
    }

    /**
     * Set data for use by table
     *
     * @param listData
     */
    processData(listData) {
        this.setState({
            summaryList: listData,
            summaryTableData: listData
        });
    }

    /**
     * Update selected table data based on sort
     *
     * @param event
     * @param table
     */
    handleSortChange = (event, table) => {
        const tableData = getTableState(table);
        this.setState({
            summaryTableData: tableData
        });
    };

    /**
     * Update selected table data based on filter
     *
     * @param event
     * @param table
     */
    handleFilterChange = (event, table) => {
        const tableData = getTableState(table);
        this.setState({
            summaryTableData: tableData
        });
    };

    /**
     * Handle event to retrieve current state of table data
     *
     * @param event
     */
    handleExportClick = (event) => {
        // CSVLink handles generation and export of CSV
    };

    render() {

        const {
            allowLocationSelection,
            endDate,
            locationIconFunction,
            startDate,
            system,
            tableFilename,
            tableKey,
            tableLabel
        } = this.props;

        const {
            summaryList,
            summaryTableData,
            summaryTableHeaders
        } = this.state;

        const dateString = convertStartAndEndDatesForFile(startDate, endDate);
        const defaultSort = setDefaultTableSort('location_id');
        const iconStyle = (allowLocationSelection) ? tableStyles.tableIconButton : tableStyles.disabledTableIconButton;

        // Headers and columns for ReactTable
        const tableColumns = [
            {
                Header: 'Location',
                columns: [
                    {
                        Header: 'Location ID',
                        accessor: 'location_id',
                        sortMethod: (a, b) => sortNumber(a, b, 'ASC'),
                        Cell: row => (
                            <span>
                        <span>{row.row.location_id}</span>
                        <DetailIcon
                            onClick={(e) => locationIconFunction(e, row.row)}
                            style={iconStyle}
                        />
                    </span>
                        ),
                        style: tableStyles.right,
                    },
                    {
                        Header: 'Location Name',
                        accessor: 'location_name'
                    },
                    {
                        Header: 'City',
                        accessor: 'city'
                    },
                    {
                        Header: 'State',
                        accessor: 'state',
                        style: tableStyles.tdMax,
                    },
                    {
                        Header: 'DBA',
                        accessor: 'dba_name'
                    }
                ]
            },
            {
                Header: 'Transactions',
                columns: [
                    {
                        Header: () => (<span>Total<br/>Items Sold</span>),
                        accessor: 'total_sold',
                        sortMethod: (a, b) => sortCurrency(a, b),
                        filterable: false,
                        style: tableStyles.right,
                        width: 125,
                        Footer: (
                            <span style={tableStyles.footer}>
                                {toCurrency(addFromColumn(summaryTableData, 'total_sold'))}
                            </span>
                        )
                    },
                    {
                        Header: () => (<span>Total<br/>Returned</span>),
                        accessor: 'total_returned',
                        sortMethod: (a, b) => sortCurrency(a, b),
                        filterable: false,
                        style: tableStyles.right,
                        width: 125,
                        Footer: (
                            <span style={tableStyles.footer}>
                                {toCurrency(addFromColumn(summaryTableData, 'total_returned'))}
                            </span>
                        )
                    },
                    {
                        Header: 'Net Sales',
                        accessor: 'net_total',
                        sortMethod: (a, b) => sortCurrency(a, b),
                        filterable: false,
                        style: tableStyles.right,
                        width: 125,
                        Footer: (
                            <span style={tableStyles.footer}>
                                {toCurrency(addFromColumn(summaryTableData, 'net_total'))}
                            </span>
                        )
                    }
                ]
            }
        ];

        return (
            <div>
                <div className="reports-table-container">

                    {/* Table Header */}
                    <div className="reports-table-title table-table-header">
                        <div className="btn-report-container report-header-button-container">
                            {/* Export Button */}
                            <FlatButton
                                primary
                                type="button"
                                label=""
                                style={commonStyles.headerButton}
                            >
                                <ExportIcon style={commonStyles.headerButtonIcon}/>
                                <CSVLink
                                    data={summaryTableData}
                                    headers={summaryTableHeaders}
                                    filename={`${tableFilename}-${system}-${dateString}.csv`}
                                    onClick={(e) => this.handleExportClick(e)}
                                    target="_blank"
                                    style={commonStyles.headerButtonLink}
                                >
                                    Export {tableLabel}
                                </CSVLink>
                            </FlatButton>
                        </div>
                        <h3 className="table-table-header-title">
                            <TableIcon style={commonStyles.summaryIcon}/>
                            <span>{tableLabel}</span>
                        </h3>
                    </div>

                    {/* Tables: Display and Print */}
                    <ReactTable
                        key={`table-${tableFilename}-${tableKey}`}
                        data={summaryList}
                        columns={tableColumns}
                        defaultPageSize={5}
                        showPagination={true}
                        defaultSorted={defaultSort}
                        filterable
                        defaultFilterMethod={filterCaseInsensitive}
                        onSortedChange={(e) => this.handleSortChange(e, this.locationsReacttable)}
                        onFilteredChange={(e) => this.handleFilterChange(e, this.locationsReacttable)}
                        ref={(r) => this.locationsReacttable = r}
                        resizable={false}
                        minRows={1}
                        className="-striped overflow no-print"
                    />
                    <ReactTable
                        key={`table-${tableFilename}-print-${tableKey}`}
                        data={summaryTableData}
                        columns={tableColumns}
                        defaultPageSize={10000}
                        showPagination={false}
                        defaultSorted={defaultSort}
                        filterable
                        resizable={false}
                        minRows={1}
                        className="print-only"
                    />
                </div>
            </div>
        )
    }
}

LocationSalesTable.propTypes = {
    addField: PropTypes.bool,
    endDate: PropTypes.string,
    allowLocationSelection: PropTypes.bool,
    listData: PropTypes.array,
    locationIconFunction: PropTypes.func,
    startDate: PropTypes.string,
    system: PropTypes.string,
    tableFilename: PropTypes.string,
    tableKey: PropTypes.string,
    tableLabel: PropTypes.string
};

LocationSalesTable.defaultProps = {
    addField: true,
    endDate: null,
    allowLocationSelection: true,
    startDate: null,
    tableFilename: 'Locations',
    tableKey: 'locations',
    tableLabel: 'Locations'
};

export default LocationSalesTable;



// WEBPACK FOOTER //
// ./src/Fuse/components/LocationSalesTable.js